import {
    GET_REPORT_TITLES,
    GET_REPORT_ALERTS,
    GET_USERS,
    SET_ALERT_STATUS,
    SET_ALERT_FILTER
} from "./types";
import firebase from "firebase/app";
export const getReportTitles = () => {
    return dispatch => {
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/report_titles/`)
                        .on(`value`, snapshot => {
                            dispatch({
                                type: GET_REPORT_TITLES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_REPORT_TITLES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORT_TITLES.FAIL });
        }
    };
};

export const getAlerts = () => {
    return dispatch => {
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/alerts/new_report`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORT_ALERTS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_REPORT_ALERTS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORT_ALERTS.FAIL });
        }
    };
};
export const getUsers = () => {
    return dispatch => {
        dispatch({ type: GET_USERS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_USERS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_USERS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_USERS.FAIL });
        }
    };
};
export const setAlertStatus = (timestamp = false,actionTaken = false, supplierReference = false, status = false, callback) => {
    
    return dispatch => {
        dispatch({ type: SET_ALERT_STATUS.REQUEST });
        if (timestamp && status) {
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/subjects/alerts/new_report/${timestamp}`)
                            .update({
                                resolved_by: user.uid,
                                status: status,
                                actionTaken:actionTaken,
                                supplierReference:supplierReference
                            })
                            .then(() => {
                                callback(true);
                                dispatch({ type: SET_ALERT_STATUS.SUCCESS });
                            });
                    } else {
                        callback(false);
                        dispatch({ type: SET_ALERT_STATUS.FAIL });
                    }
                });
            } catch {
                callback(false);
                dispatch({ type: SET_ALERT_STATUS.FAIL });
            }
        } else {
            callback(false);
            dispatch({ type: SET_ALERT_STATUS.FAIL });
        }
    };
};
export const setAlertFilter = status => {
    return dispatch => {
        dispatch({ type: SET_ALERT_FILTER, payload: status });
    };
};
